import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../_helpers';

// create slice

const name = 'creditcard';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const creditcardActions = { ...slice.actions, ...extraActions };
export const creditcardsReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        creditcards: {},        // For getAll() - all cards
        userCreditCards: {},    // For getAllByUser() - filtered cards
        defaultValue: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/user`;

    return {
        getAll: getAll(),
        getAllByUser: getAllByUser()
    };

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetCreditCards`),
            { condition: (_, { getState }) => !Array.isArray(getState().creditcards.creditcards) }
        );
    }

    function getAllByUser() {
        return createAsyncThunk(
            `${name}/getAllByUser`,
            async () => await fetchWrapper.get(`${baseUrl}/GetCreditCardsByUser`)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll(),
        ...getAllByUser()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.creditcards = { loading: true };
            },
            [fulfilled]: (state, action) => {
                // state.creditcards = action.payload;               

                state.creditcards = action.payload?.sort((a, b) => {
                    if (a.cc_active === true && b.cc_active === false) {
                        return -1; // a should come before b
                    }
                    if (a.cc_active === false && b.cc_active === true) {
                        return 1; // a should come after b
                    }
                    return 0; // no sorting needed
                });



                const authUser = JSON.parse(localStorage.getItem('user'));
                if (authUser) {
                    state.defaultValue = action.payload.find(obj => {
                        return obj.cc_user_id.toLowerCase() == authUser.user.user_id.toLowerCase() // Unable to get logged-in user's Credit Card as cc_user_id value is in all lowercase. FIX - convert both user_ids to lowercase
                    })
                }
                if (state.defaultValue) {
                    localStorage.setItem('ccValue', JSON.stringify(state.defaultValue));
                } else {
                    const obj = { cc_active: '', cc_id: '', cc_name_on_card: '', cc_nbr: 'Select...', cc_user_id: '' };

                    localStorage.setItem('ccValue', JSON.stringify(obj));
                }
            },
            [rejected]: (state, action) => {
                state.creditcards = { error: action.error };
            }
        };
    }

    function getAllByUser() {
        var { pending, fulfilled, rejected } = extraActions.getAllByUser;
        return {
            [pending]: (state) => {
                state.userCreditCards = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.userCreditCards = action.payload;

                // Set default to logged-in user's card if available in the list
                const authUser = JSON.parse(localStorage.getItem('user'));
                if (authUser && action.payload) {
                    state.defaultValue = action.payload.find(obj => {
                        return obj.cc_user_id == authUser.user.user_id
                    });
                }
            },
            [rejected]: (state, action) => {
                state.userCreditCards = { error: action.error };
            }
        };
    }
}
